import { FbConnectURL, XeroConnectURL, Accountant, DMUrls, KSURLS, VcPortal, NotificationURLS, CategoryURLS, LMS } from './../enums/urls';
import { CommonEnum } from './../enums/common';
import { RedirectRoutes } from './../enums/routes';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, forwardRef, NgZone } from '@angular/core';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { AlertService } from './alert.service';
import { AlertInfo } from '../enums/alert-info';
import { HttpMethod } from '../enums/http-handlers';
import { BehaviorSubject, Observable } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Grid } from '../models/grid';
// import * as CanvasJS from '../../../canvasjs.min';
import { Subscription, interval } from 'rxjs';
import { AppUrl, DATA_USAGE_URLS, LOGIN, SubcriptionReminder, URLS, USER, QbConnectURL } from '../enums/urls';
import { JsonAppNames } from '../enums/jsonfilename';
import { checkNullorUndefined } from '../utilities/functions/checknullorundefined';
import * as CryptoJS from 'crypto-js';
import { DomSanitizer } from '@angular/platform-browser';
// EditorJS imports moved to dynamic imports for lazy loading (~500KB+ bundle savings)
// import EditorJS from '@editorjs/editorjs';
import { AppCode } from '../enums/app-codes';
import { NoOrganizationComponent } from '../../components/no-organization/no-organization.component';
// EditorJS plugins - dynamically loaded when needed
// import Header from '@editorjs/header';
// import Marker from '@editorjs/marker';
// import Table from '@editorjs/table';
// import ImageTool from '@editorjs/image';
// XLSX moved to lazy loading below
// import LinkTool from '@editorjs/link';
// import List from '@editorjs/list';
// import BreakLine from 'editorjs-break-line';
// import Quote from '@editorjs/quote';
// import Checklist from '@editorjs/checklist';
// import Delimiter from '@editorjs/delimiter';
// import editorjsColumns from '@calumk/editorjs-columns';
import Swal from 'sweetalert2';
// XLSX lazy-loaded to reduce main bundle (~500KB savings)
// import * as XLSX from 'xlsx';
// import MathEditor from 'editorjs-mathlive';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';
import { ModalSize } from '../enums/modal-info';
import { UserInstituteProfileComponent } from 'src/app/shared/components/user-institute-profile/user-institute-profile.component';
// import { TReaderDocument } from '@usewaypoint/email-builder';

// EditorJS lazy loading cache
let EditorJSModules: {
  EditorJS: any;
  Header: any;
  Marker: any;
  Table: any;
  ImageTool: any;
  LinkTool: any;
  List: any;
  BreakLine: any;
  Quote: any;
  Checklist: any;
  Delimiter: any;
  editorjsColumns: any;
  MathEditor: any;
} | null = null;

async function loadEditorJSModules() {
  if (EditorJSModules) return EditorJSModules;
  
  const [
    EditorJSModule,
    HeaderModule,
    MarkerModule,
    TableModule,
    ImageToolModule,
    LinkToolModule,
    ListModule,
    BreakLineModule,
    QuoteModule,
    ChecklistModule,
    DelimiterModule,
    editorjsColumnsModule,
    MathEditorModule
  ] = await Promise.all([
    import('@editorjs/editorjs'),
    import('@editorjs/header'),
    import('@editorjs/marker'),
    import('@editorjs/table'),
    import('@editorjs/image'),
    import('@editorjs/link'),
    import('@editorjs/list'),
    import('editorjs-break-line'),
    import('@editorjs/quote'),
    import('@editorjs/checklist'),
    import('@editorjs/delimiter'),
    import('@calumk/editorjs-columns'),
    import('editorjs-mathlive')
  ]);
  
  EditorJSModules = {
    EditorJS: EditorJSModule.default,
    Header: HeaderModule.default,
    Marker: MarkerModule.default,
    Table: TableModule.default,
    ImageTool: ImageToolModule.default,
    LinkTool: LinkToolModule.default,
    List: ListModule.default,
    BreakLine: BreakLineModule.default,
    Quote: QuoteModule.default,
    Checklist: ChecklistModule.default,
    Delimiter: DelimiterModule.default,
    editorjsColumns: editorjsColumnsModule.default,
    MathEditor: MathEditorModule.default
  };
  
  return EditorJSModules;
}

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  private _pageTitle: BehaviorSubject<string> = new BehaviorSubject<string>('AI');
  pageTitle = this._pageTitle.asObservable();
  currentUser: any = null;
  isTestAccount: any = false;
  setupData: any = null;
  availableAppsData: any;
  showAccSWs: boolean = false;
  accSWdata: any;
  profileurl: string = '';
  column_tools: any;
  headers: any;
  imageUrl: any;
  showSpinner: BehaviorSubject<boolean>;
  messages: BehaviorSubject<any>;
  mytagsList: any = [];
  botCategories: any = [];
  botGroupName: any = '';
  getBotGroupsData: any = [];
  tutorGroupCount: number = 0;
  currentUserDetails: any;
  gradeLevelData: any = [];

  setPageTitle(title: string = 'AI') {
    this._pageTitle.next(title);
  }
  visibility: BehaviorSubject<boolean>;
  // myapps: any;
  cartcount: any = 0;
  tableColumnsData: any;
  commonDashBoardData: any;
  subscription: Subscription = new Subscription();
  newOrgSourceId: any;
  showConnectButton: boolean = false;
  modalReference: any;
  showCompanies: boolean = false;
  companiesData: any;
  getStartedData: any;
  params: HttpParams = new HttpParams();
  pageindex: any = 1;
  appDashBoardData: any = [];
  appDashBoardData1: any = null;
  editor: any;
  editor2: any;
  editor3: any;
  editor4: any;
  editor5: any;
  editor6: any;
  editor7: any;
  videoLink: any = '';
  grid: Grid = new Grid();
  acclist: any = [];
  public getConfigProps = new BehaviorSubject<any>(null);
  public getUserMeData = new BehaviorSubject<any>(null);
  primarybfemId: any;
  portaltabAppCode: string = 'A10.AC';


  constructor(
    private http: HttpClient,
    private router: Router,
    public sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private alertService: AlertService,
    public appService: AppService,
    public sessionService: SessionService,
    private apiService: ApiService,
    private ngZone: NgZone
  ) {
    this.cartcount = new BehaviorSubject<any>(0);
    this.visibility = new BehaviorSubject<boolean>(false);
    this.showSpinner = new BehaviorSubject<boolean>(false);
    this.messages = new BehaviorSubject<any>([]);
  }

  // CONFIGURATION: TReaderDocument = {
  //   root: {
  //     type: 'EmailLayout',
  //     data: {
  //       backdropColor: '#F8F8F8',
  //       canvasColor: '#FFFFFF',
  //       textColor: '#242424',
  //       fontFamily: 'MODERN_SANS',
  //       childrenIds: ['block-1709578146127'],
  //     },
  //   },
  //   'block-1709578146127': {
  //     type: 'Text',
  //     data: {
  //       style: {
  //         fontWeight: 'normal',
  //         padding: {
  //           top: 16,
  //           bottom: 16,
  //           right: 24,
  //           left: 24,
  //         },
  //       },
  //       props: {
  //         text: 'Hello world',
  //       },
  //     },
  //   },
  // };
  show() {
    this.visibility.next(true);
  }

  showSpinnerMethod() {
    this.visibility.next(true);
    this.showSpinner.next(true);
    // console.log('Visibility:', true);
  }

  hide() {
    this.visibility.next(false);
  }

  hideSpinnerMethod() {
    this.visibility.next(false);
    this.showSpinner.next(false);
    // console.log('Visibility:', false);
  }

  // cart Count Update
  getCheckoutApps() {
    this.commonApiCall(
      SubcriptionReminder.CART,
      HttpMethod.GET,
      null,
      (result: any, statusFlag: boolean) => { // Explicitly specify the type of 'statusFlag' as 'boolean'
        if (statusFlag) {
          this.cartcount = result?.count;
        }
      }
    );
  }
  // notificationsByAppCount() {
  //   const url = NotificationURLS.allAppsCount;
  //   this.commonApiCall(
  //     url,
  //     HttpMethod.GET,
  //     null,
  //     (res: any, statusFlag: boolean) => {
  //       if (statusFlag) {
  //         this.notificationsCount = res.vCuount + res.acCount + res.ppCount + res.ecCount + res.fuCount;
  //       }
  //       this.hide();

  //     }
  //   );
  // }

  async editorJsInit(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editorjs');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit2(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor2 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor2js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit3(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor3 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor3js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit4(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor4 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor4js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit5(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor5 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor5js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit6(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor6 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor6js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  async editorJsInit7(editorJsBlockData?: any[], readyOnly: boolean = false) {
    await loadEditorJSModules();
    this.editor7 = this.editorJsToolBar(editorJsBlockData, readyOnly, 'editor7js');
    // first define the tools to be made avaliable in the columns
    this.column_tools = this.editorJsColumnTools();
    // this.editor.readOnly.toggle();
  }

  editorJsToolBar(editorJsBlockData: any, readOnly: boolean, editor: string) {
    if (!EditorJSModules) {
      console.error('EditorJS modules not loaded. Call editorJsInit first.');
      return null;
    }
    const { EditorJS, Header, Marker, Table, ImageTool, LinkTool, List, BreakLine, Quote, Checklist, Delimiter, editorjsColumns, MathEditor } = EditorJSModules;
    
    let editorJsToolBar: any = new EditorJS({
      placeholder: readOnly ? '' : 'Click here to write something!',
      autofocus: false,
      holder: editor,
      readOnly: readOnly,
      inlineToolbar: ['link', 'marker', 'bold', 'italic'],
      data: {
        time: 1552744582955,
        blocks: editorJsBlockData || [],
        version: "2.27.0"
      },
      tools: {
        header: {
          class: Header,
          inlineToolbar: ['link']
        },
        math: {
          class: MathEditor,
          inlineToolbar: true,
          config: {
            virtualKeyboardMode: 'manual',
            defaultMode: 'math',
            smartMode: true,
            virtualKeyboardTheme: 'material',
          },
        },
        list: {
          class: List,
          inlineToolbar: true,
          config: {
            defaultStyle: 'unordered'
          }
        },
        checklist: {
          class: Checklist,
        },
        marker: {
          class: Marker,
          shortcut: 'CMD+SHIFT+M'
        },
        table: {
          class: Table,
          inlineToolbar: true,
          config: {
            rows: 2,
            cols: 3,
          },
        },
        linkTool: {
          class: LinkTool,
          config: {
            endpoint: DMUrls.editorGetLink // Your backend endpoint for url data fetching,
          }
        },
        columns: {
          class: editorjsColumns,
          config: {
            tools: this.column_tools, // IMPORTANT! ref the column_tools
          }
        },
        image: {
          class: ImageTool,
          config: {
            endpoints: {
              byFile: DMUrls.editorFileload, // Your backend file uploader endpoint
              byUrl: environment.fileFetchUrl, // Your endpoint that provides uploading by Url
            }
          }
        },
        // embed: {
        //   class: Embed,
        //   inlineToolbar: true,
        //   config: {
        //     services: {
        //       youtube: true,
        //       coub: true,
        //       imgur: true
        //     }
        //   }
        // },
        delimiter: Delimiter,
        // image: SimpleImage,
        quote: {
          class: Quote,
          inlineToolbar: true,
          shortcut: 'CMD+SHIFT+O',
          config: {
            quotePlaceholder: 'Enter a quote',
            captionPlaceholder: 'Quote author',
          },
        },
        // warning: {
        //   class: Warning,
        //   inlineToolbar: true,
        //   shortcut: 'CMD+SHIFT+W',
        //   config: {
        //     titlePlaceholder: 'Title',
        //     messagePlaceholder: 'Message',
        //   },
        // },
        breakLine: {
          class: BreakLine,
          inlineToolbar: true,
          shortcut: 'CMD+SHIFT+ENTER',
        },
      },
    });
    return editorJsToolBar;
  }

  editorJsColumnTools() {
    if (!EditorJSModules) {
      console.error('EditorJS modules not loaded.');
      return {};
    }
    const { Header, Marker, List, Checklist, Table, LinkTool, ImageTool, Delimiter, Quote, BreakLine, editorjsColumns, MathEditor } = EditorJSModules;
    
    let column_tools = {
      header: {
        class: Header,
        inlineToolbar: ['link']
      },
      list: {
        class: List,
        inlineToolbar: true,
        config: {
          defaultStyle: 'unordered'
        }
      },

      checklist: {
        class: Checklist,
      },
      marker: {
        class: Marker,
        shortcut: 'CMD+SHIFT+M'
      },
      table: {
        class: Table,
        inlineToolbar: true,
        config: {
          rows: 2,
          cols: 3,
        },
      },
      linkTool: {
        class: LinkTool,
        config: {
          endpoint: DMUrls.editorGetLink // Your backend endpoint for url data fetching,
        }
      },
      image: {
        class: ImageTool,
        config: {
          endpoints: {
            byFile: DMUrls.editorFileload, // Your backend file uploader endpoint
            byUrl: environment.fileFetchUrl, // Your endpoint that provides uploading by Url
          }
        }
      },
      // embed: {
      //   class: Embed,
      //   inlineToolbar: true,
      //   config: {
      //     services: {
      //       youtube: true,
      //       coub: true,
      //       imgur: true
      //     }
      //   }
      // },
      delimiter: Delimiter,
      // image: SimpleImage,
      quote: {
        class: Quote,
        inlineToolbar: true,
        shortcut: 'CMD+SHIFT+O',
        config: {
          quotePlaceholder: 'Enter a quote',
          captionPlaceholder: 'Quote author',
        },
      },
      breakLine: {
        class: BreakLine,
        inlineToolbar: true,
        shortcut: 'CMD+SHIFT+ENTER',
      },
    }
    return column_tools;
  }

  editorJsDestroy() {
    if (this.editor && typeof this.editor.destroy === 'function') {
      this.editor.destroy();
      this.editor = null;
    }

  }

  editor2JsDestroy() {
    if (this.editor2 && typeof this.editor2.destroy === 'function') {
      this.editor2.destroy();
      this.editor2 = null;
    }
  }

  editor3JsDestroy() {
    if (this.editor3 && typeof this.editor3.destroy === 'function') {
      this.editor3.destroy();
      this.editor3 = null;
    }
  }

  editor4JsDestroy() {
    if (this.editor4 && typeof this.editor4.destroy === 'function') {
      this.editor4.destroy();
      this.editor4 = null;
    }
  }

  editor5JsDestroy() {
    if (this.editor5 && typeof this.editor5.destroy === 'function') {
      this.editor5.destroy();
      this.editor5 = null;
    }
  }

  editor6JsDestroy() {
    if (this.editor6 && typeof this.editor6.destroy === 'function') {
      this.editor6.destroy();
      this.editor6 = null;
    }
  }

  editor7JsDestroy() {
    if (this.editor7 && typeof this.editor7.destroy === 'function') {
      this.editor7.destroy();
      this.editor7 = null;
    }
  }

  editorJsViewer(editorJsBlockData: any) {
    // let result: any = Parser(editorJsBlockData)
    let result: any = null;
    return result;
  }

  pipeDate(val: any) {
    let latest_date = val.value;
    return latest_date;
  }

  //Object Comparsion
  IsObjectsMatch(mainObject: any, cloneObject: any) {
    return (JSON.stringify(mainObject) === JSON.stringify(cloneObject));
  }

  config = {
    height: 60,
    placeholder: 'Write here',
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
    fontNamesIgnoreCheck: ['Merriweather'],
    disableDragAndDrop: true,
    toolbar: [
      // [groupName, [list of button]]
      ['style', ['bold', 'italic', 'underline']],
      ['font'],
      ['fontsize', ['fontsize']],
      ['fontName', ['Arial']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['insert', ['link']],
    ]
  }
  config2 = {
    height: 60,
    placeholder: 'Write here',
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
    fontNamesIgnoreCheck: ['Merriweather'],
    toolbar: [
      // [groupName, [list of button]]
      ['style', ['bold', 'italic', 'underline']],
      ['font'],
      ['fontsize', ['fontsize']],
      ['para', ['ul', 'ol']],
      ['fontName', ['Arial']],
      ['insert', ['link']],
    ]
  }

  refreshPage() {
    setInterval(() => {
      location.reload();
    }, 28800000);
  }

  SetupOrganization() {
    const url = URLS.Setup;
    this.commonApiCall(
      url,
      HttpMethod.POST,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          // this.installedApps();
          this.getAppConfig(false);
          // this.getSubMenu();
          // this.getAppConfigJson();
        }
      }
    );
  }

  // installedApps() {
  //   const url = AppUrl.installedApps + '/' + this.appService.getUserDetails().id;
  //   this.commonApiCall(
  //     url,
  //     HttpMethod.GET,
  //     null, (res: any, statusFlag: boolean) => {
  //       if (statusFlag) {
  //         res.listResult.forEach((a: any) => { // Explicitly specify the type of the parameter 'a'
  //           this.appService.checkSubscriptionTime(a.code);
  //           a.status = this.appService.trailInfo;
  //         });
  //         this.installedApps = res.listResult; // Fix: Change 'filterinstalledApps' to 'installedApps'
  //         const installedData = JSON.parse(localStorage.getItem("installedAccApp"));
  //         const obj = this.installedApps.find(res => res.code == installedData); // Fix: Change 'filterinstalledApps' to 'installedApps'
  //         localStorage.removeItem('installedAccApp');
  //         obj && this.openApp(obj.segment1)
  //         this.getAppConfig(false, false, false);
  //       }
  //       this.hide();;
  //     }
  //   );
  // }

  cartCountHandler(res: any) {
    // this.cartTotalcount =res;
    this.cartcount.next(res);
  }
  cartCountSub() {
    return this.cartcount.asObservable();
  }
  cartCountClear() {
    this.cartcount.next(null);
  }
  // getDashBoardData
  getDashBoardData(appCode: string, type = 'grid') {
    this.appDashBoardData = [];
    this.appDashBoardData1 = {};
    this.params = new HttpParams()
      .set("pageindex", this.pageindex.toString())
      .set("pagesize", "5");
    this.commonApiCall(
      DATA_USAGE_URLS.DASHBOARD + '/' + appCode + '?' + this.params,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag && res) {
          this.commonDashBoardData = res.common;
          if (res.dbResults && res.dbResults.length) {
            type == 'grid' ? this.gridForm(res.dbResults) : this.dataList(res.dbResults);
          }
          // this.gettingStarted(res, appCode);
          // this.router.navigate([RedirectRoutes.DASHBOARD]);
        }
        this.hideSpinnerMethod();
      }
    );
  }

  getStartedVideo(name: string) {
    const url = URLS.getStartesApps
    this.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          res.listResult.forEach((v: any) => { // Explicitly specify the type of the parameter 'v'
            if (v.name == name) {
              this.getStartedData = v;
              this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.getStartedData?.link);
            }
          });
        }
        this.hideSpinnerMethod();
      }
    );
  }
  gotoHomePage() {
    if (this.appService.getUserDetails()) {
      this.router.navigate([this.currentUser?.mainRole != 'Mentee' ? '/app/learn/ai-tools/list' : '/app/learn/rooms/private-rooms']);
    } else {
      this.logOut();
    }
  }

  logOut(isLogout = true) {
    this.currentUser = this.appService.getUserDetails();
    this.isTestAccount = this.currentUser?.isTestAccount;
    this.appService.trailInfo = '';
    if (isLogout) {
      this.commonApiCall(
        LOGIN.logout,
        HttpMethod.GET,
        null,
        (result: any, statusFlag: boolean) => {
          if (statusFlag) {
            // if (this.sessionService.loginTimerId) {
            //   this.sessionService.clearLoginTimeInterval();
            // }
            this.appService.remainingHours.next(0);
            this.appService.remainingMinutes.next(0);
            this.appService.remainingSeconds.next(0);
            this.appService.showTimerConfrmOpened = false;
            this.appService.showTimerConfrm = false;
            this.cmnLogout();
            // this.appService.modalRef.close();
          }
        });
    } else {
      this.cmnLogout()
    }
  }

  private cmnLogout() {
    Swal.close();
    if (this.sessionService.timerId) {
      clearInterval(this.sessionService.timerId);
    }
    // this.modal.dismiss('Cross click');
    localStorage.clear();
    if (!this.isTestAccount) {
      this.router.navigate([RedirectRoutes.LOGIN]);
    }
    else {
      this.router.navigate(['login' + '/' + this.currentUser?.email + '/$A8demo@']);
    }
    this.hideSpinnerMethod();
  }

  gridForm(result: any) {
    this.grid = new Grid();
    this.grid.ViewVisible = false;
    this.appDashBoardData = this.appService.onGenerateJson(result, this.grid);
  }

  dataList(result: any) {
    this.appDashBoardData1 = {};
    this.appDashBoardData = result;
    const dataAxis: any = [];
    const data: any = [];
    for (let r = 0; r < result.length; r++) {
      dataAxis.push(`${result[r].category}-${result[r].month}`);
      data.push(result[r].count);
    }
    const yMax: number = 2000;
    const dataShadow: any = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < data.length; i++) {
      dataShadow.push(yMax);
    }
    this.appDashBoardData1 = {
      color: ['#3398DB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: dataAxis,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [{
        type: 'value'
      }],
      series: [{
        name: 'Counters',
        type: 'bar',
        barWidth: '60%',
        data: data
      }]
    };

  }

  chartRender(chartdata: any[], result: any[]) {
    // let chart = new CanvasJS.Chart("chartContainer", {
    //   axisX: {
    //     labelMaxWidth: 100
    //   },
    //   animationEnabled: true,
    //   // exportEnabled: true,
    //   title: {
    //     text: (result.length > 0) ? result[0].orgName : ""
    //   },
    //   data: [
    //     {
    //       type: "column",
    //       dataPoints: chartdata
    //     }
    //   ]
    // });
    // chart.render();
  }

  startTimmer() {
    this.stopTimmer();
    const date = this.appService.getToken();
    this.appService.loginTime = new Date();
    const expireDate: any = new Date(new Date().getTime() + date.sessionTime * 60000);
    let obj = { startDateTime: this.appService.loginTime, sessionTime: date.sessionTime, expireDate: expireDate };
    localStorage.setItem("loggedInTime", JSON.stringify(obj));

    // const expireDate: any = new Date(new Date().getTime() + date.sessionTime * 60000);
    // this.subscription = interval(1000).subscribe(x => { this.appService.loginTimerRun(expireDate); });

  }

  refreshToken() {
    const store = this.appService.getToken();
    this.commonApiCall(
      LOGIN.RefreshToken,
      HttpMethod.POST,
      {
        token: store.accessToken,
        refreshToken: store.refreshToken,
      },
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.appService.setToken(res);
          this.appService.showTimerConfrmOpened = false;
          this.appService.showTimerConfrm = false;
          this.appService.remainingHours.next(0);
          this.appService.remainingMinutes.next(0);
          this.appService.remainingSeconds.next(0);
          this.startTimmer();
        } else {
          this.logOut(false);
        }
      }
    );
  }

  getPublicBotGroups() {
    const url = LMS.getBotGroups;
    this.params = new HttpParams()
      .set("kabId", '')
      .set("orderBy", '')
      .set("status", '')
      .set("type", 'public')
      .set("myGroups", false)
      .set("name", this.botGroupName);
    this.commonApiCall(
      url + "?" + this.params,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: any) => {
        if (statusFlag) {
          this.getBotGroupsData = res.listResult;
          this.tutorGroupCount = res.count;
        }
        this.hide();;
      }
    );
  }

  stopTimmer() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.appService.loginTimerId) {
      this.appService.clearLoginTimeInterval();
    }
    this.appService.remainingHours.next(0);
    this.appService.remainingMinutes.next(0);
    this.appService.remainingSeconds.next(0);
  }

  checkAppSetup(appcode: string) {
    this.setupData = null;
    const url = URLS.AppSetup;
    this.commonApiCall(
      url + '/' + appcode,
      HttpMethod.GET,
      null, (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.setupData = res;
        }
      }
    );
  }
  getAvailableApps(appcode: string) {
    this.params = new HttpParams()
      .set("isForPricing", 'false');
    const url = AppUrl.AVAILABLE_APPS + '/' + this.currentUser?.id + '?' + this.params;
    this.commonApiCall(
      url,
      HttpMethod.GET,
      null, (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.availableAppsData = res.listResult;
          this.executeAppSetup(appcode);
        }
      }
    );
  }

  executeAppSetup(appcode: string) {
    let selectedApps: any[] = [];
    if (appcode == AppCode.HTF) {
      this.availableAppsData.forEach((el: any) => {
        selectedApps.push(el?.acM_Id);
      });
    }
    let object = {
      acM_Ids: selectedApps,
    };
    const url = URLS.AppSetup;
    this.commonApiCall(
      url + '/' + appcode,
      HttpMethod.POST,
      object,
      (result: any, statusFlag: boolean) => { // Explicitly specify the type of 'result' as 'any'
        if (statusFlag) {
          this.getAppConfig(true, false, false);
        }
      }
    );
  }

  getAppConfig(canNavigate = true, isAppRequired = true, canSubScribe = true) {
    this.commonApiCall(
      USER.USER_DETAILS,
      HttpMethod.GET,
      null,
      (result: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.appService.removeUserDetails();
          this.appService.setUserDetails(result);
          this.currentUserDetails = result;
          if (isAppRequired) {
            this.getApps(result, canNavigate, canSubScribe);
          }
        }
        this.hideSpinnerMethod();
      }
    );
  }



  getApps(data: any, canNavigate: boolean, canSubScribe = true) {
    this.commonApiCall(
      AppUrl.myApps,
      HttpMethod.GET,
      null,
      (result: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.appService.setMenu(result.listResult);
          result.listResult.forEach((a: any) => {
            this.appService.myAppsList?.push(a);
            this.appService.checkSubscriptionTime(a.appCode);
            a.status = this.appService.trailInfo;
          });
          if (canNavigate) {
            localStorage.setItem("lmportaltermsAgreed", 'no');
            if (data?.currentOrgId == 0 || data?.currentOrgId == undefined) {
              this.modalReference = this.modalService.open(NoOrganizationComponent, {
                size: 'lg',
                keyboard: false,
                backdrop: "static",
                centered: true
              });
              this.hideSpinnerMethod();
              this.modalReference.result.then((result: any) => {
                if (result == 'Cross click') {
                  this.logOut();
                  setTimeout(
                    function () {
                      location.reload();
                    }, 500);
                }
              });
              // this.router.navigate([RedirectRoutes.NOORGANIZATIONBYID]);
            }
            else {
              if (data?.landingPage == null || data?.landingPage == '') {
                this.router.navigate([data?.mainRole != 'Mentee' ? '/app/learn/ai-tools/list' : '/app/learn/rooms/private-rooms']);
              }
              else if (data?.landingPage == 'rooms') {
                this.router.navigate([data?.mainRole != 'Mentee' ? '/app/learn/rooms/public-rooms' : '/app/learn/rooms/private-rooms']);
              }
              else if (data?.landingPage == 'favorites') {
                this.router.navigate(['/app/learn/favorites/rooms']);
              }
              else if (data?.landingPage == 'ai-tutors') {
                this.router.navigate(['/app/learn/ai-tutors/public']);
              }
              else if (data?.landingPage == 'feed') {
                this.router.navigate(['/app/learn/feed']);
              }
              else if (data?.landingPage == 'ai-tools') {
                this.router.navigate(['/app/learn/ai-tools/list']);
              }
            }
            //  else if (data?.mainRole == 'Mentee') {
            //   this.router.navigate(['/app/learn/rooms/public-rooms']);
            // if (this.checkNetworkAccess(data)) {
            //   this.router.navigate([RedirectRoutes.PROADVISOR]);
            // } else
            // if (data?.mainRole != 'User' || data?.mainRole != 'HTM_User') {
            //   this.router.navigate([RedirectRoutes.HOMELABEL]);
            // }
            // if (data?.mainRole == 'User' || data?.mainRole == 'HTM_User') {
            //   this.router.navigate([RedirectRoutes.APPS]);
            // }
            // else if (data.userType == 'CB' && data?.mainRole != 'User') {
            //   this.params = new HttpParams()
            //     .set("pageindex", "1")
            //     .set("pagesize", "50");
            //   const url = VcPortal.vendorsList + this.params;
            //   this.commonApiCall(
            //     url,
            //     HttpMethod.GET,
            //     null,
            //     (res: any, statusFlag: boolean) => {
            //       if (statusFlag) {
            //         this.acclist = res.listResult;
            //         if (data?.accSW == 'QBO') {
            //           if (this.acclist.length == 0) {
            //             this.router.navigate([RedirectRoutes.FU_CLIENT_LANDING_URL]);
            //           }
            //           else {
            //             this.router.navigate([RedirectRoutes.MY_ACCOUNTANT_URL + '/' + this.primarybfemId]);
            //           }
            //         }
            //         else if (data?.accSW == 'FBO') {
            //           this.router.navigate([RedirectRoutes.APPS]);
            //         }
            //       }
            //       this.hide();
            //     }
            //   );
            // }
            // else if (data.userType == 'CB' && data?.mainRole == 'User' && data.roles.find(a => a == 'Accountant_Workspace') ? true : false) {
            //   this.router.navigate([RedirectRoutes.FU_CLIENT_LIST_LANDING_URL]);
            // }
            // else if (data.userType == 'CB' && data?.mainRole == 'User' && (data.roles.find(a => a == 'Accountant_Workspace') ? false : true)) {
            //   this.router.navigate([RedirectRoutes.APPS]);
            // }
            // else {
            //   this.router.navigate([RedirectRoutes.DASHBOARD]);
            // }
            // }
            // else if (result?.landingPage == null) {
            //   this.router.navigate(['/app/learn/rooms/public-rooms']);
            // }
            // else if (result?.landingPage == 'rooms') {
            //   this.router.navigate(['/app/learn/rooms/public-rooms']);
            // }
            // else if (result?.landingPage == 'favourites') {
            //   this.router.navigate(['/app/learn/favorites/rooms']);
            // }
            // else if (result?.landingPage == 'ai-tutors') {
            //   this.router.navigate(['/app/learn/ai-tutors/public']);
            // }
            // else if (result?.landingPage == 'feed') {
            //   this.router.navigate(['/app/learn/feed']);
            // }

          }
          if (canSubScribe) {
            this.getUserMeData.next(result);
          }            // if (canNavigate) {
          //   localStorage.setItem("lmportaltermsAgreed", 'no');
          //   if (result.currentOrgId == 0 || result.currentOrgId == undefined) {
          //     this.router.navigate([RedirectRoutes.ORGANIZATION]);
          //   } else {
          //     this.router.navigate(['/app/learn/rooms/public-rooms']);
          //   }
          // }
          // if (canSubScribe) {
          //   this.getUserMeData.next(result);
          // }
        }
        this.hideSpinnerMethod();
      }
    );
  }

  checkNetworkAccess(data: any) {
    if (data.userType === 'CA' || data.userType === 'CB') {
      // if (data.mainRole != 'User') {
      //   return true;
      // }
      if (data.mainRole != 'Master Admin') {
        if (data.roles.find((a: string) => a == 'Network_Access')) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return true;
      }
    }
    else if (data.userType == 'HT') {
      return true;
    }
    else {
      return false;
    }
  }
  encryptData(data: any) {
    const securityKey = '7061737323313233';
    if (data) {
      let key = CryptoJS.enc.Utf8.parse(securityKey);
      let iv = CryptoJS.enc.Utf8.parse(securityKey);
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return this.replaceChar(encrypted.toString());
    }
    return '';
  }
  replaceChar(value: string) {
    value = value.replace('/', 'Advisor8');
    return value
  }
  encrypt(value: string, securityKey: string) {
    if (value && securityKey) {
      let key = CryptoJS.enc.Utf8.parse(securityKey);
      let iv = CryptoJS.enc.Utf8.parse(securityKey);
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

      return encrypted.toString();
    }
    return ''
  }

  replaceChar2(value: string) {
    value = value.replace('Advisor8', '/');
    return value
  }

  decryptData(data: any) {
    data = this.replaceChar2(data);
    const securityKey = '7061737323313233';
    const bytes = CryptoJS.AES.decrypt(data, securityKey);
    if (data) {
      var key = CryptoJS.enc.Utf8.parse(securityKey);
      var iv = CryptoJS.enc.Utf8.parse(securityKey);
      var decrypted = CryptoJS.AES.decrypt(data, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }
  }
  getAccountantsList() {
    this.params = new HttpParams()
      .set("pageindex", "1")
      .set("pagesize", "50");
    const url = VcPortal.vendorsList + this.params;
    this.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.acclist = res.listResult;
          this.acclist.forEach((el: any) => {
            if (el?.primaryAccountant == true) {
              this.primarybfemId = el?.bfeM_Id;
            }
          });

          // console.log(this.acclist)
        }
      }
    );
  }


  getExistedApps() {
    this.commonApiCall(
      AppUrl.myApps,
      HttpMethod.GET,
      null,
      (result: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.appService.setMenu(result.listResult);
        }
      }
    );
  }

  checkMuiltipleAccSw(data: any) {
    this.showAccSWs = true;
    this.showCompanies = false;
    this.accSWdata = data;
    this.accSWdata.accSWs.forEach((a: any) => {
      if (a.isNewOrg) {
        this.newOrgSourceId = a.source_Id;
      }
    });
    // this.accSWdata.accSWs.filter(res => res.isPrimaryAccSW == true && res.org_Id==this.oldOrgId);
  }
  checkMuiltipleCompanies(data: any) {
    this.showAccSWs = false;
    this.showCompanies = true;
    this.companiesData = data;
  }
  createCompany(sourceId: any, accSW: any) {
    this.alertService.closePopup(CommonEnum.XEROCREATECOMPANY, (result: any) => {
      if (result) {
        let obj = {
          accSWAccessToken: this.accSWdata.accSWAccessToken,
          accSWRefreshToken: this.accSWdata.accSWRefreshToken,
          accSWAccessTokenExpiresIn: this.accSWdata.accSWAccessTokenExpiresIn,
          accSWRefreshTokenExpiresIn: this.accSWdata.accSWRefreshTokenExpiresIn,
          createCA: false,
          accSW: accSW,
          source_Id: sourceId
        }
        this.commonApiCall(
          FbConnectURL.createOrg,
          HttpMethod.POST,
          obj,
          (res: any, statusFlag: boolean) => {
            if (statusFlag) {
              this.appService.setToken(res);
              this.getAppConfig();
              // this.getSubMenu();
              // this.getAppConfigJson();
            }
          }
        );
      }
    });
  }
  createCompanyAfterCallBack(sourceId: any, accSW: any) {
    this.alertService.closePopup(CommonEnum.XEROCREATECOMPANY, (result: any) => {
      if (result) {
        let obj = {
          accSWAccessToken: this.companiesData.accSWAccessToken,
          accSWRefreshToken: this.companiesData.accSWRefreshToken,
          accSWAccessTokenExpiresIn: this.companiesData.accSWAccessTokenExpiresIn,
          accSWRefreshTokenExpiresIn: this.companiesData.accSWRefreshTokenExpiresIn,
          accSW: accSW,
          source_Id: sourceId
        }
        this.commonApiCall(
          FbConnectURL.createOrgAfterCallBack,
          HttpMethod.POST,
          obj,
          (res: any, statusFlag: boolean) => {
            if (statusFlag) {
              if (res.hasMoreOrgs == false && res.hasMuiltipleAccSWs) {
                this.appService.setToken(res);
                this.checkMuiltipleAccSw(res);
              }
              else {
                this.appService.setToken(res);
                this.getAppConfig();
                // this.getSubMenu();
                // this.getAppConfigJson();
              }
            }
          }
        );
      }
    });
  }
  continueCompany(orgId: any, accSW: any) {
    this.alertService.closePopup(CommonEnum.XEROMERGECOMPANY, (result: any) => {
      if (result) {
        let obj = {
          accSWAccessToken: this.accSWdata.accSWAccessToken,
          accSWRefreshToken: this.accSWdata.accSWRefreshToken,
          accSWAccessTokenExpiresIn: this.accSWdata.accSWAccessTokenExpiresIn,
          accSWRefreshTokenExpiresIn: this.accSWdata.accSWRefreshTokenExpiresIn,
          createCA: true,
          accSW: accSW,
          source_Id: this.newOrgSourceId,
          org_Id: orgId
        }
        this.commonApiCall(
          FbConnectURL.createOrg,
          HttpMethod.POST,
          obj,
          (res: any, statusFlag: boolean) => {
            if (statusFlag) {
              this.appService.setToken(res);
              this.getAppConfig();
              // this.getSubMenu();
              // this.getAppConfigJson();
            }
          }
        );
      }
    });
  }
  qbdisconnect() {
    this.alertService.closePopup(CommonEnum.QBDISCONNECT, (result: any) => {
      if (result) {
        this.commonApiCall(
          QbConnectURL.qbDissconnect,
          HttpMethod.POST,
          null,
          (result: any, statusFlag: boolean) => {
            if (statusFlag) {
              this.getAppConfig(false);
              this.showConnectButton = true;
            }
          }
        );
        this.modalReference.close();
      }
    });
  }

  xerodisconnect() {
    this.alertService.closePopup(CommonEnum.XERODISCONNECT, (result: any) => {
      if (result) {
        this.commonApiCall(
          XeroConnectURL.xerodissconnect,
          HttpMethod.POST,
          null,
          (result: any, statusFlag: boolean) => {
            if (statusFlag) {
              this.getAppConfig(false);
              this.showConnectButton = true;
            }
          }
        );
        this.modalReference.close();
      }
    });
  }
  getSubMenu(): any {
    this.http.get('../../../assets/configuration/menuList.json').subscribe((data) => {
      this.appService.setSubMenu(data);
    });
  }

  // getGrapes(): any {
  //   this.http.get('../../../assets/configuration/grapes.json').subscribe((data) => {
  //     
  //     localStorage.setItem('data',JSON.stringify(data));
  //     console.log(JSON.parse(localStorage.getItem('data')));
  //   });
  // }

  getAppConfigJson() {
    // this.http.get('../../../assets/configuration/app-config.json').subscribe((data: any) => {
    //   this.appService.setAppConfig(data);
    // });
  }


  redirectToSupport() {
    let url = "/support";
    window.open(url, "_blank");
  }

  getJsonData(screenName: string, json: any, callBack: any) {
    this.http
      .get(this.getUrl(json))
      .subscribe((data: any) => {
        let configsData = data.find((el: any) => el.name === screenName);
        if (configsData) {
          this.appService.setConfigProps(configsData);
          this.headers = configsData?.configs?.gridDisplayProps;
        }
        callBack(true)
      });
  }

  getUrl(json: any) {
    switch (json) {
      case JsonAppNames.FRAMEWORK: return 'assets/configuration/app-modules/frame-work.json';
      case JsonAppNames.ACCOUNTANT: return 'assets/configuration/app-modules/accountant.json';
      case JsonAppNames.AUDITS: return 'assets/configuration/app-modules/audits.json';
      case JsonAppNames.KNOWLEDGESHARE: return 'assets/configuration/app-modules/knowledgeshare.json';
      case JsonAppNames.LICENSURE: return 'assets/configuration/app-modules/lm.json';
      case JsonAppNames.BDIRECTORY: return 'assets/configuration/app-modules/business-directory.json';
      case JsonAppNames.VCPORTAL: return 'assets/configuration/app-modules/vc-portal.json';
      case JsonAppNames.CRM: return 'assets/configuration/app-modules/crm.json';
      case JsonAppNames.EMAILREAD: return 'assets/configuration/app-modules/email-read.json';
      case JsonAppNames.EMAILCAMPAIGN: return 'assets/configuration/app-modules/email-campaign.json';
      case JsonAppNames.DYNAMICFORMS: return 'assets/configuration/app-modules/dynamicforms.json';
      case JsonAppNames.BEANADVISOR: return 'assets/configuration/app-modules/beanadvisor.json';
      case JsonAppNames.JOBS: return 'assets/configuration/app-modules/jobs.json';
      case JsonAppNames.OM: return 'assets/configuration/app-modules/om.json';
      case JsonAppNames.UTILITIES: return 'assets/configuration/app-modules/main-apps.json';
      case JsonAppNames.FIXUNCAT: return 'assets/configuration/app-modules/fix-uncat.json';
      default:
        return 'assets/configuration/app-modules/frame-work.json';
    }
  }


  // getemailcampaignConfigProps
  getEmailCampaignConfigProps(screenName: string) {
    // this.http
    //   .get('../../../assets/configuration/app-modules/email-campaign.json')
    //   .subscribe((data: any) => {
    //     let configsData = data.find((el: any) => el.name === screenName);
    //     if (configsData) {
    //       this.appService.setConfigProps(configsData);
    //     }
    //     this.getConfigProps.next(true);
    //   });
  }

  getDynamicformsConfigProps(screenName: string) {
    // this.http
    //   .get('../../../assets/configuration/app-modules/dynamicforms.json')
    //   .subscribe((data: any) => {
    //     let configsData = data.find((el: any) => el.name === screenName);
    //     if (configsData) {
    //       this.appService.setConfigProps(configsData);
    //     }
    //     this.getConfigProps.next(true);
    //   });
  }


  formatDate(event: any) {
    const time = new Date();
    // tslint:disable-next-line: one-variable-per-declaration
    const date = new Date(event),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2),
      hours = ('0' + time.getHours()).slice(-2),
      minutes = ('0' + time.getMinutes()).slice(-2),
      seconds = ('0' + time.getSeconds()).slice(-2);
    return `${[mnth, day, date.getFullYear()].join('-')} ${[
      hours,
      minutes,
      seconds,
    ].join(':')}`;
  }

  formatDateValue(event: any) {
    const time = new Date();
    // tslint:disable-next-line: one-variable-per-declaration
    const date = new Date(event),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return `${[day, mnth, date.getFullYear()].join('-')}`;
  }

  formatReportDate(event: any) {
    var time = new Date();
    var date = new Date(event),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2),
      hours = ('0' + time.getHours()).slice(-2),
      minutes = ('0' + time.getMinutes()).slice(-2),
      seconds = ('0' + time.getSeconds()).slice(-2);
    return `${[date.getFullYear(), mnth, day].join('/')} ${[
      hours,
      minutes,
      seconds,
    ].join(':')}`;
  }
  apiHandler(methodType: HttpMethod, url: string, requestObj: any) {
    switch (methodType) {
      case HttpMethod.POST:
        return this.apiService.commonPostHandler(url, requestObj);
      case HttpMethod.PUT:
        return this.apiService.commonPutHandler(url, requestObj);
      case HttpMethod.DELETE:
        return this.apiService.commonDeleteHandler(url);
      case HttpMethod.GET:
        return this.apiService.commonGetHandler(url);
      default:
        return this.apiService.commonGetHandler(url);
    }
  }
  // common Post Api need to use in all screens
  commonApiCall(url: string, methodType: HttpMethod, requestObj: any, callBack: any, endUserMessage?: any) {
    // this.show();
    this.showSpinnerMethod();
    this.apiHandler(methodType, url, requestObj).subscribe({
      next: (res: any) => {
        if (
          !checkNullorUndefined(res) &&
          res.hasOwnProperty('response')
        ) {
          if (res.hasOwnProperty('isSuccess') && res.isSuccess) {
            this.getMessages(res, AlertInfo.SUCCESS, methodType, endUserMessage ?? true);
            callBack(res.response, true);
          } else if (res.hasOwnProperty('isSuccess') && !res.isSuccess) {
            this.getMessages(res, AlertInfo.ERROR, methodType, endUserMessage ?? true);
            this.hideSpinnerMethod();
            callBack(res, false);
          }
        }
      },
      error: (error: any) => {
        this.hideSpinnerMethod();
        callBack(null, false);
        // this.alertService.showMessage(AlertInfo.ERROR, error);
      }
    });
  }

  private getMessages(res: any, type: AlertInfo, methodType: HttpMethod, endUserMessage: boolean) {
    if (methodType == HttpMethod.GET && type == AlertInfo.SUCCESS) {
      return;
    }
    if (
      !checkNullorUndefined(res.endUserMessage) && res.endUserMessage != '' && endUserMessage
    ) {
      this.alertService.showMessage(type, res.endUserMessage);
    }
  }

  checkDate(date: Date, subDate: Date) {
    if ((new Date(date) < new Date() && subDate == null) || new Date(subDate) < new Date() && new Date(date) < new Date()) {
      return true;
    }
    else {
      return false;
    }
    return false;
  }

  getQuickBookUrl() {
    this.commonApiCall(
      QbConnectURL.QuikBookUrl,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => { // Explicitly specify the type of 'statusFlag' as 'boolean'
        if (statusFlag) {
          this.getAppConfig();
          this.appService.hideModel();
        }
      }
    );
  }

  getFreshBookUrl() {
    // location.replace(FbConnectURL.ConnectUrl);
  }
  getXeroUrl() {
    location.replace(XeroConnectURL.XeroUrl);
  }

  clearObserbels() {
    this.getConfigProps.next(null);
  }

  exportTo(data: any, file = 'data', ext: string) {
    if (ext === 'Excel') {
      this.printReport(data, file);
    } else if (ext === 'CSV') {
      this.jsonToCSV(data, file);
    }
  }
  // to print report - XLSX lazy-loaded for bundle size optimization

  async printReport(data: any[], filename: string) {
    const XLSX = await import('xlsx');
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, `${filename}.xlsx`); // initiate a file download in browser
  }
  jsonToCSV(data: any[], filename: string) {
    if (data.length) {
      // i.e converting CSV file to JSON
      const csvData = this.ConvertToCSV(data, Object.keys(data[0]));
      const blob = new Blob(['\ufeff' + csvData], {
        type: 'text/csv;charset=utf-8;',
      });
      const dwldLink = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const isSafariBrowser =
        navigator.userAgent.indexOf('Safari') != -1 &&
        navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {
        // if Safari open in new window to save file with random filename.
        dwldLink.setAttribute('target', '_blank');
      }
      dwldLink.setAttribute('href', url);
      dwldLink.setAttribute('download', filename + '.csv');
      dwldLink.style.visibility = 'hidden';
      document.body.appendChild(dwldLink);
      dwldLink.click();
      // document.body.removeChild(dwldLink);
    }
  }
  ConvertToCSV(objArray: any[], headerList: string[]) {
    const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }
  redirectAdvisorProfile(url: string) {
    // Guard: Don't proceed if url is empty/null/undefined
    if (!url || url.trim() === '') {
      return;
    }
    
    const userType = this.appService.getUserDetails()?.userType;
    
    if (userType == 'CB' || userType == 'HT') {
      // Navigate to profile page for CB and HT users
      this.profileurl = `/app/learn/network/profile/${url}`;
      window.open(this.profileurl, '_blank');
    }
    else if (userType == 'CA') {
      // Open modal for CA users
      this.ngZone.run(() => {
        this.modalReference = this.modalService.open(UserInstituteProfileComponent, {
          windowClass: 'modal-holder',
          keyboard: false,
          size: ModalSize.DAILOGLARGE,
          backdrop: 'static',
        });
        this.modalReference.componentInstance.profileUrl = url;
      });
    }
  }
  saveBase64ToServer(form: any) {
    this.commonApiCall(
      DMUrls.quillFileload,
      HttpMethod.POST,
      form,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          // quill.html = quill.html.replace(el.insert.image, res);
          this.imageUrl = res;
        }
      },
    );
    return this.imageUrl;
  }
  // convertExcelToJSON(event, callBack) {
  //   let xlsxFiles = null;
  //   let jsonData = [];
  //   const columns = [];
  //   const reader = new FileReader();
  //   // this.commonService.show();
  //   const file = event[0];
  //   reader.onload = () => {
  //     xlsxFiles = XLSX.read(reader.result, { type: 'binary', cellDates: true });
  //     jsonData = xlsxFiles.SheetNames.reduce((initial, name) => {
  //       const sheet = xlsxFiles.Sheets[name];
  //       initial[name] = XLSX.utils.sheet_to_json(sheet, {
  //         raw: false,
  //         defval: '',
  //       });
  //       return initial;
  //     }, {});
  //     for (const key in jsonData) {
  //       if (jsonData[key].length) {
  //         columns.push({ Id: key, Text: key });
  //       } else {
  //         delete jsonData[key];
  //       }
  //     }
  //  this.hide();
  //     if (columns.length) {
  //       callBack(jsonData, columns);
  //     } else {
  //       this.toastr.error(this.appService.getErrorText('2660076'));
  //       callBack(null);
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }

  clearCommonService() {
    this.commonDashBoardData = null;
    this.commonDashBoardData = null;
  }

  ngAfterViewInit(): void {
    $('#kt_datatable_example').DataTable({
      // Configuration options
      paging: true,
      searching: true,
      ordering: true,
    });
  }

  getMyTags() {
    const url = KSURLS.getMastertags;
    this.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.mytagsList = [];
          res.listResult.forEach((el: any) => { // Specify the type of 'el' as 'any'
            this.mytagsList.push(el?.value);
          });
        }
        this.hide();
      }
    );
  }

  GetCategoiresList() {
    const url = CategoryURLS.catgoryByApp + AppCode.KS;
    this.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.botCategories = [];
          this.gradeLevelData = [];
          res.listResult.forEach((element: any) => {
            switch (element.code) {
              case "KSCAT":
                this.botCategories.push(element.name);
                break;
              case "K12":
                this.gradeLevelData = [...this.gradeLevelData, element];
                break;
              default:
                break;
            }
          });
        }
        this.hide();
      }
    );
  }

  roomLaunch(data: any) {
    if (data?.activeFlag == false) {
      this.alertService.showMessage(
        AlertInfo.WARNING,
        'Room is currently inactive. Please get in touch with the Room administrator for further assistance.');
    }
    else {
      let url = `app/learn/room-launch/${(data?.room_Id)}/home`;
      this.router.navigate([url]);
    }
  }

  getAbsoluteValue(amount: number): number {
    return Math.abs(amount);
  }

}
